import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { IconEdit01 } from "@pentabd/icons";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import dayjs from "dayjs";

import isUpdateButtonShownHandler from "@utils/isUpdateButtonShown";

export const SoftwareHistoryTableColumn = (
  t: TFunction<"translation", undefined>,
  data: any,
  openHistoryModalHandler: (historyId: number | null) => void,
) => {
  return [
    {
      id: 1,
      key: "partyName",
      name: t("SOFTWARE_INVENTORY.SOFTWARE_HISTORY.TABLE.COLUMN.PARTY_NAME"),
      render: (partyName: string) => {
        return (
          <>
            <Text className="text-nowrap text-info" component="p">
              {partyName}
            </Text>
          </>
        );
      },
    },
    {
      id: 2,
      key: "maintenanceContactSignOffDate",
      name: t("SOFTWARE_INVENTORY.SOFTWARE_HISTORY.TABLE.COLUMN.SIGN_OFF_DATE"),
      render: (signOffDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {signOffDate}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "maintenanceContactExpiryDate",
      name: t("SOFTWARE_INVENTORY.SOFTWARE_HISTORY.TABLE.COLUMN.EXPIRY_DATE"),
      render: (expireData: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {expireData}
          </Text>
        );
      },
    },
    {
      id: 4,
      key: "maintenanceContactExpiryDate",
      name: "",
      render: (expireData: string, row: any) => {
        dayjs.extend(isSameOrAfter);
        const isExpired = dayjs().isSameOrAfter(dayjs(expireData));

        const isShown = isUpdateButtonShownHandler(
          row?.id,
          data?.softwareHistory,
        );

        return isShown &&
          isExpired &&
          data?.maintenanceParty === "Third Party" ? (
          <IconEdit01
            size={24}
            fill="subtitle1"
            onClick={() => openHistoryModalHandler(row?.id)}
          />
        ) : (
          <></>
        );
      },
    },
  ];
};
